<ng-container *ngIf="kbaEnable && isKbaShowed">
  <p class="ibk-description">
    Para validar correctamente tu identidad debes responder las siguientes preguntas de seguridad.
  </p>

  <ng-container *ngIf="(questions$ | async)?.kba as kba">
    <ng-container *ngFor="let question of kba.questions; let i = index">
      <p class="ibk-question">{{ question.text }}</p>

      <ibk-input-radio-group
        dsRxForm="radioChange"
        class="radio-group"
        [id]="'radio-idx-' + i"
        [formControl]="$any(questionsForm.get(i + ''))"
        name="question-{{ i }}"
      >
        <ibk-input *ngFor="let option of question.options; let j = index" [id]="'radio-id-' + i + '-' + j">
          <span>{{ option.text }}</span>
          <input [value]="option.id" />
        </ibk-input>
      </ibk-input-radio-group>
    </ng-container>
  </ng-container>

  <ibk-toast *ngIf="haveAuthError" type="WARN">
    Este usuario ha sido bloqueado por demasiados intentos de preguntas KBA en este período
  </ibk-toast>

  <ibk-toast *ngIf="showTooManyAttemptsError" type="WARN">
    Has excedido el número máximo de intentos de verificación de identidad. Podrás intentarlo más tarde.
  </ibk-toast>

  <ibk-toast *ngIf="showBadAttemptError" type="INFO"> Respuestas incorrectas. Intenta de nuevo. </ibk-toast>

  <ibk-button class="ba-action" *ngIf="!haveAuthError" [loading]="isLoading">
    <button
      (click)="answerKbaQuestions()"
      id="answer-kba-questions"
      [disabled]="!this.canDoAnswer"
      class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
    >
      Continuar
    </button>
  </ibk-button>
</ng-container>

<ng-container *ngIf="biometryEnable && iframeSrc && isBiometryShowed">
  <iframe #iframe [src]="iframeSrc" class="ibk-iframe" allow="camera; microphone"></iframe>
</ng-container>
